require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/fn/array/from.js
// module id = 1146
// module chunks = 168707334958949